import React from 'react';
import './tutorial-modal.css';
import { Icon } from '../../icon';
import { Heading } from '../../heading';
import Copy from '../../../copy/tutorials';
import { Paragraph } from '../../paragraph';
const TutorialModal = props => {
    const { screen } = props;

    const iconName = screen === 'speaker' ? 'parliament' : screen;

    return (
        <>
            <header className="tutorial-modal__header">
                <Icon
                    iconName={iconName}
                    colorScheme="dark"
                    withSpacing={true}
                    altText=""
                />
                <div className="tutorial-modal__header-heading">
                    <Heading
                        headingType="h3"
                        colorScheme="dark"
                        align="center"
                        withSpacing={false}
                    >
                        {Copy[screen].header}
                    </Heading>
                </div>
            </header>
            <div className="tutorial-modal__content">
                <Paragraph colorScheme="dark" withSpacing={false}>
                    {Copy[screen].content}
                </Paragraph>
                <Paragraph colorScheme="dark" withSpacing={true}>
                    <b>TOP TIP:</b> {Copy[screen].tip}
                </Paragraph>
            </div>
        </>
    );
};

export { TutorialModal };
